import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles, Calendar, MapPin, Clock, Check, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import HeroSlider from '../components/HeroSlider';
import ExpertiseAreas from '../components/ExpertiseAreas';
import TestimonialsGrid from '../components/TestimonialsGrid';
import AboutTaner from '../components/AboutTaner';
import Results from '../components/Results';
import ContactSection from '../components/ContactSection';
import EmailCTA from '../components/EmailCTA';
import { FunnelIntelligence } from '../components/funnel';
import TrainingCardsSection from '../components/TrainingCardsSection';

const HomePage = () => {
  return (
    <FunnelIntelligence>
      <main className="bg-black pb-20 md:pb-0">
        {/* Hero Slider */}
        <HeroSlider />

      {/* Trainings Section - Dynamic from DB */}
      <div id="trainings-section">
        <TrainingCardsSection limit={8} showHeader={true} />
      </div>

      {/* Expertise Areas */}
      <ExpertiseAreas />

      {/* Testimonials */}
      <TestimonialsGrid />

      {/* About Taner */}
      <AboutTaner />

      {/* Contact Section */}
      <ContactSection />

      {/* Email CTA */}
      <EmailCTA />

      {/* Mobile Sticky CTA - Premium Design */}
      <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden" data-testid="mobile-sticky-cta">
        <div className="bg-gradient-to-t from-black via-black/95 to-transparent pt-6 pb-5 px-4">
          <Link
            to="/masterclass"
            className="group relative block"
          >
            {/* Outer glow */}
            <div className="absolute -inset-[2px] rounded-2xl bg-gradient-to-r from-purple-600/50 via-fuchsia-500/40 to-purple-600/50 blur-sm" />
            {/* Gradient border */}
            <div className="absolute -inset-[1px] rounded-2xl bg-gradient-to-r from-purple-500/50 via-fuchsia-400/35 to-purple-500/50" />
            {/* Button body */}
            <div className="relative bg-[#0d0518]/95 backdrop-blur-2xl px-5 py-4 rounded-2xl flex items-center justify-between overflow-hidden">
              {/* Top highlight */}
              <div className="absolute top-0 left-[10%] right-[10%] h-[1px] bg-gradient-to-r from-transparent via-purple-300/20 to-transparent" />
              {/* Text */}
              <span className="text-white text-sm font-bold tracking-wider">MASTERCLASS EĞİTİMİNE KATILIN</span>
              {/* Arrow circle */}
              <div className="relative flex-shrink-0 ml-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-600/60 to-fuchsia-600/40 border border-purple-400/25 flex items-center justify-center group-hover:from-purple-500/70 group-hover:to-fuchsia-500/50 transition-all duration-300">
                  <ArrowRight className="w-4 h-4 text-white/90" />
                </div>
              </div>
              {/* Bottom accent */}
              <div className="absolute bottom-0 left-[5%] right-[5%] h-[1px] bg-gradient-to-r from-transparent via-purple-500/15 to-transparent" />
            </div>
          </Link>
        </div>
      </div>
    </main>
    </FunnelIntelligence>
  );
};

export default HomePage;